import { useEffect, useMemo, useRef } from "react";
import { useSetReadMessageMutation } from "web_myplann/Api/Chat/useSetReadMessageMutation";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

const isUnreadIncoming = (message: ChatMessageView) =>
	message.direction === "recipient" && !message.isRead;

const getNewestUnreadIncomingId = (messages: ChatMessageView[]) => {
	const unreadIncomingIds = messages.filter(isUnreadIncoming).map((m) => m.id);

	return unreadIncomingIds.length > 0 ? Math.max(...unreadIncomingIds) : null;
};

export const useMarkChatMessagesRead = (
	conversationId: number | null,
	messages: ChatMessageView[],
) => {
	const { mutate: setReadMessage } = useSetReadMessageMutation();
	const markedKeyRef = useRef<string | null>(null);

	const newestUnreadIncomingId = useMemo(
		() => getNewestUnreadIncomingId(messages),
		[messages],
	);

	useEffect(() => {
		if (conversationId === null || newestUnreadIncomingId === null) return;

		const markedKey = `${conversationId}:${newestUnreadIncomingId}`;
		if (markedKeyRef.current === markedKey) return;
		markedKeyRef.current = markedKey;

		setReadMessage({ conversationId, messageId: newestUnreadIncomingId });
	}, [conversationId, newestUnreadIncomingId, setReadMessage]);
};
